import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { dataFieldsService, FieldType } from 'src/services';

/**
 * Actions
 */
export const merchandisingRulesListContainerActions = {
  getDataFields: createAsyncThunk(
    'MerchandisingRulesListContainer/GetDataFields',
    async (
      { shopId, fieldType }: { shopId: number; fieldType?: FieldType },
      { rejectWithValue }
    ) => {
      try {
        const dataFields = await dataFieldsService.getDataFields({ shopId, fieldType });
        return { dataFields };
      } catch (error) {
        return rejectWithValue({ error });
      }
    }
  ),
  navigateTo: createAction<{ navigateTo: string }>('MerchandisingRulesListContainer/NavigateTo'),
};
